import { render, staticRenderFns } from "./BusinessUnitSelectBox.vue?vue&type=template&id=2b2f02a5&scoped=true&"
import script from "./BusinessUnitSelectBox.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f02a5",
  null
  
)

export default component.exports